import { Window } from "@progress/kendo-react-dialogs";
import { templateData } from "../../Template/NewTemplateSignals";
import { conditionalRowFormattingVisibility } from "../Store/CommonSignals";
import ConditionRowRuleBuilder from "./ConditionRowRuleBuilder";

export const ConditionRowBuilderWindow = () => {
  const handlePropertyChange = ({ propName, propValue }) => {
    templateData.value = {
      ...templateData.value,
      properties: {
        ...templateData.value.properties,
        [propName]: propValue,
      },
    };
  };

  return (
    <>
      {conditionalRowFormattingVisibility.value && (
        <Window
          onClose={() => (conditionalRowFormattingVisibility.value = false)}
          initialHeight={500}
          initialWidth={800}
          title={"Conditional Row Formatting Rules Manager"}
        >
          <ConditionRowRuleBuilder
            handlePropertyChange={handlePropertyChange}
            onClose={() => (conditionalRowFormattingVisibility.value = false)}
          />
        </Window>
      )}
    </>
  );
};
